import { BaseHttpService } from "@kernel/frontend-react-app";
import { HttpRequest } from "@kernel/frontend-react-app";
import { LoadConfigService } from "../interactors/config/LoadConfigInteractors";

export class ConfigService
  extends BaseHttpService
  implements LoadConfigService
{
  constructor() {
    const baseUrl = import.meta.env.VITE_WEB_URL || window.location.origin;
    const fetch: HttpRequest = HttpRequest.create(baseUrl);
    super(fetch);
  }

  public async loadConfig(key: string): Promise<unknown[]> {
    return await this.get(`config/${key}`);
  }

  public async saveConfig(path: string, configs: unknown): Promise<void> {
    await this.post("/", { path, configs });
  }
}
